<template>
  <div id="tinymce" :style="{ width: width }">
    <vue-tinymce
      :value="value"
      @input="(val) => $emit('input', val)"
      :init="setting"
    />
    <div class="notice">{{ notice }}</div>
  </div>
</template>

<script>
//样式
import Vue from "vue";
import tinymce from "tinymce/tinymce";
Vue.prototype.tinymce = tinymce;
import uploadService from "sky-ossupload";
// import { createUpload, ossUpload } from 'sky-ossupload';
import { getDomain } from "sky-domain";
import OSS from "ali-oss";
import skyRequest from "skytech-request";
// import 'tinymce/skins/content/default/content.min.css'
// import 'tinymce/skins/ui/oxide/content.min.css'
// import "tinymce/skins/ui/oxide/skin.min.css";

//主题
import "tinymce/themes/silver/theme";

// import "tinymce/skins/content/default/content.css";
// import "tinymce/themes/silver/theme.min.js";
// import "tinymce/icons/default/icons";

//插件
import "tinymce/plugins/link"; //链接插件
import "tinymce/plugins/image"; //图片插件
import "tinymce/plugins/table"; //表格插件
import "tinymce/plugins/lists"; //列表插件
import "tinymce/plugins/quickbars"; //快速栏插件
import "tinymce/plugins/fullscreen"; //全屏插件
import "tinymce/icons/default/icons";
import "tinymce/plugins/print";
import "tinymce/plugins/preview";
import "tinymce/plugins/paste";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/template";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/charmap";
import "tinymce/plugins/hr";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/anchor";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/advlist";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/help";
import "tinymce/plugins/autosave";
// import 'tinymce/plugins/autoresize';

//本地化
import VueTinymce from "@tinymce/tinymce-vue";
import "./tinymce/langs/zh_CN.js";
// import { mapGetters } from 'vuex';

export default {
  name: "sky-rich-text",
  // props: ['value', 'scope', 'platform', 'toolbar'],
  props: {
    value: {
      type: String,
      default: ""
    },
    platform: {
      type: String,
      default: ""
    },
    toolbar: {
      type: String,
      default: ""
    },
    notice: {
      type: String,
      default: ""
    },
    judgeSize: {
      // 文件大小判断
      required: false,
      default: 0
    },
    minHeight: {
      // 最小高度判断
      required: false,
      default: 200
    },
    height: {
      // 高度
      required: false,
      default: 200
    },
    maxHeight: {
      // 最大高度判断
      required: false,
      default: 200
    },
    width: {
      type: String,
      default: "100%"
    },
    beforeImageUpload: {
      type: Function,
      default: () => {}
    },
    imageUploadSuccess: {
      type: Function,
      default: () => {}
    },
    imageUploadfail: {
      type: Function,
      default: () => {}
    },
    contentStyle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      setting: {
        selector: "#textarea1",
        // width: 350,
        height: this.height,
        branding: false,
        auto_focus: false,
        menubar: false,
        resize: false,
        // min_height: this.minHeight,
        maxHeight: this.maxHeight,
        statusbar: false,
        contextmenu: false,
        language: "zh_CN",
        // language_url: "/static/tinymce/langs/zh_CN.js",
        content_style: this.contentStyle,
        fontsize_formats:
          "12px 13px 14px 15px 16px 18px 20px 24px 36px 48px 64px 72px",
        font_formats:
          "微软雅黑=Microsoft YaHei;苹果苹方=PingFang SC;宋体=simsun;Andale Mono=andale mono;Arial=arial;Arial Black=arial black;Book Antiqua=book antiqua;Comic Sans MS=comic sans ms;Courier New=courier new;Georgia=georgia;Helvetica=helvetica;Impact=impact;Symbol=symbol;Tahoma=tahoma;Terminal=terminal;Trebuchet MS=trebuchet ms;Verdana=verdana;Webdings=webdings;Wingdings=wingdings",
        skin_url: "/static/tinymce/skins/ui/oxide",
        content_css: "/static/tinymce/skins/content/default/content.css",
        toolbar:
          this.toolbar ||
          "undo redo | fontselect fontsizeselect | numlist bullist | alignleft aligncenter alignright alignjustify  formatselect| image |  forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
        quickbars_insert_toolbar: "",
        quickbars_selection_toolbar:
          "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins:
          "paste print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount image imagetools textpattern help autosave link  table lists fullscreen quickbars",
        images_upload_handler: async (blobInfo, success, failure) => {
          const file = blobInfo.blob();
          this.beforeImageUpload && this.beforeImageUpload(file);
          try {
            let oss = uploadService({
              request: skyRequest,
              getHost: getDomain,
              platform: this.platform || "oa-pub-oss"
            });
            let convert = await oss.convert({ file });
            let result = await oss.fileUpload({
              ...convert,
              fileName: file.fileName,
              OSS
            });
            this.imageUploadSuccess && this.imageUploadSuccess(result);
            success(result.url.split("?")[0]);
          } catch (e) {
            this.imageUploadfail && this.imageUploadfail(e);
            failure(e);
          }
        }
      }
    };
  },
  mounted() {
    tinymce.init({});
  },
  methods: {
    init() {}
  },
  components: {
    VueTinymce
  }
};
</script>




<style scoped lang="scss">
#tinymce {
  .notice {
    color: #f56c6c;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/formComponents/sky-rich-text.vue